import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '@/lib/animations';
import { PRODUCTS } from '@/lib/constants';

/* ── Static grid — shows every product at once, no interaction required ── */
export default function ProductsGrid() {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-100px' }}
      variants={staggerContainer}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto"
    >
      {PRODUCTS.map((product) => {
        return (
          <motion.div
            key={product.title}
            variants={fadeInUp}
            data-testid={`product-card-${product.title.toLowerCase().replace(/\s/g, '-')}`}
            className="glass-card glass-card-hover overflow-hidden flex flex-col min-h-[440px]"
          >
            <div
              className="relative h-[220px] w-full flex-shrink-0"
              style={{ background: 'rgba(var(--c-purple-rgb),0.16)' }}
            >
              {product.image && (
                <img src={product.image} alt={product.title} className="absolute inset-0 w-full h-full object-contain" />
              )}
            </div>

            <div className="p-8 flex flex-col flex-1">
              <span className="text-[10px] font-bold tracking-[0.18em] uppercase mb-2" style={{ color: 'var(--c-purple-400)' }}>
                {product.tag}
              </span>
              <h3 className="text-xl font-bold text-brand-white mb-3 tracking-tight">{product.title}</h3>
              <p className="text-sm text-brand-muted leading-relaxed mb-5">{product.desc}</p>

              {product.bullets ? (
                <ul className="space-y-2.5">
                  {product.bullets.map((b) => (
                    <li key={b} className="flex items-center gap-3 text-sm text-brand-off-white">
                      <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: 'var(--c-purple-400)' }} />
                      {b}
                    </li>
                  ))}
                </ul>
              ) : (<p>No features available</p>)}
            </div>
          </motion.div>
        );
      })}
    </motion.div>
  );
}
